<nav class="navbar bg-transparent" style="margin: 0">
  <div class="container">
    <a class="navbar-brand" routerLink='/home'><img src="./../../assets/images/logo.png" class="navbar-logo"></a>
    <div class="navbar-expand ml-auto navbar-nav">
      <div class="navbar-nav">Foundation Shade Finder</div>
    </div>
  </div>
</nav>
<router-outlet></router-outlet>